import React, {useState, useEffect} from 'react';
import {API, Auth, Storage} from 'aws-amplify';
import PropTypes from 'prop-types';
import fetch from 'node-fetch';
import JSZip from 'jszip';
import './landscapeInfo.css';

const LandscapeInfo = (props) => {

  const [sAccount, uAccount] = useState('');
  const [sClient, uClient] = useState('');
  const [sAccounts, uAccounts] = useState([]);
  const [sRes, uRes] = useState({});
  const [sStatus, uStatus] = useState('Nothing');

  const handleGetLandscape = () => {
    // uRes('...loading')
    console.log(sAccount);
    if (sAccount) {

      API.get('WBU', '/landscape', {
        queryStringParameters: {
          // account: '058791263821'
          account: sAccount,
          client: sAccount === '597539275125' ? sClient : ''
        }
      })
      .catch(err => {
        // console.log(err);
      });

      const start = Date.now();
      const downloadLandscape = () => {

        uStatus(`Fetching data for account ${sAccount}: ${Math.floor((Date.now() - start) / 1000)}s`);

        return new Promise(resolve => {
          setTimeout(() => {
            // Storage.get(`landscapes/${sAccount}.json`)
            Storage.get(`landscapes/${sAccount}.json`)
            .then(res => {
              return fetch(res);
            })
            .then(res => {
              // console.log(res);
              return res.text();
            })
            .then(res => {
              if (res) {
                uStatus(`Data for account ${sAccount} fetched after ${Math.floor((Date.now() - start) / 1000)} seconds.`);
                uRes(JSON.parse(JSON.parse(res).body));
                console.log(JSON.parse(JSON.parse(res).body));
              }
              else {
                // console.log('waiting...');
                downloadLandscape();
              }
            });

          }, 5000);
        });


      };

      downloadLandscape();

    } else {
      uStatus('No account selected.');
    }

  };

  useEffect(() => {
    API.get('WBU', '/accounts', {})
    .then(res => {
      const accounts = JSON.parse(res.body).sort((a, b) => {
        return [a.Name, b.Name].sort()[0] === a.Name ? -1 : 1;
      });
      console.log(accounts);
      uAccounts(accounts);
    })
    .catch(err => {
      console.log(err);
    });
  }, []);

  const tab1 = sRes.tab1 ? sRes.tab1.map(instance => {
    return [
      instance.hostname,
      instance.instanceId,
      instance.cpuOptions.CoreCount,
      instance.ramAmount,
      instance.securityGroups.map(group => group.groupTagName).join(', '),
      instance.vpcName,
      instance.subnet[0].subnetName
    ].map(cell => cell === undefined ? '' : cell);
  }) : [];

  const tab2 = sRes.tab2 ? sRes.tab2.map(group => {
    return [
      group.key,
      group.name,
      group.groupId,
      group.type,
      group.protocol,
      group.portRange,
      group.ipRange,
      group.ipDescription
    ].map(cell => cell === undefined ? '' : cell);
  }) : [];

  const tab3 = sRes.tab3 ? sRes.tab3.map(volume => {
    return [
      volume.Name,
      volume.VolumeId,
      volume.Size + ' GiB',
      volume.Iops,
      `${volume.Attachments[0] ? volume.Attachments[0].InstanceName : 'None'} (${volume.Attachments[0] ? volume.Attachments[0].InstanceId : 'None'})`,
      volume.Attachments[0] ? volume.Attachments[0].Device : 'None'
    ].map(cell => cell === undefined ? '' : cell);
  }) : [];

  const tab4 = sRes.tab4 ? sRes.tab4.map(nInterface => {
    return [
      nInterface.Name,
      nInterface.NetworkInterfaceId,
      nInterface.SubnetName + ' (' + nInterface.SubnetId + ')',
      nInterface.VpcName + ' (' + nInterface.VpcId + ')',
      nInterface.Attachment && (nInterface.InstanceName + ' (' + nInterface.Attachment.InstanceId + ')'),
      nInterface.Association && nInterface.Association.PublicIp,
      nInterface.PrivateIpAddress,
      nInterface.Description
    ].map(cell => cell === undefined ? '' : cell);
  }) : [];

  const tabInfo = [
    {
      headers: ['Hostname', 'Instance ID', 'vCPU', 'RAM (GB)', 'Security Group Membership', 'Network', 'Subnet'],
      data: tab1,
      title: 'EC2 Instances'
    },
    {
      headers: ['Internal Key', 'Security Group Name', 'Security Group ID', 'Type', 'Protocol', 'Port Range', 'Source', 'Description'],
      data: tab2,
      title: 'Security Groups'
    },
    {
      headers: ['Volume Name', 'Volume ID', 'Size', 'IOPS', 'Attached Instance', 'Attached Device'],
      data: tab3,
      title: 'Volumes'
    },
    {
      headers: ['Name', 'Network Interface ID', 'Subnet', 'VPC', 'Instance', 'Public IP Address', 'Private IP Address', 'Description'],
      data: tab4,
      title: 'Network Interfaces'
    }
  ];

  const handleDownloadCsv = e => {
    e.preventDefault();
    if (sRes.tab1 || sRes.tab2 || sRes.tab3 || sRes.tab4) {

      const zip = new JSZip();

      tabInfo.forEach(tab => {
        let csvData = '';
        const visHeaders = tab.headers;
        csvData += visHeaders.join(',') + '\r\n';
        tab.data.forEach((instance) => {
          let row = instance.map(cell => {
            return `${cell.toString().replace(/"/g, '""').replace(/#/g, '-hash-')}`;
          });
          csvData += '"' + row.join('","') + '"\r\n';
        });
        zip.file(`${sAccount}-${tab.title}.csv`, csvData);
      });

      zip.generateAsync({type: 'base64'})
      .then(content => {
        // saveAs(content, `${sAccount}-Landscape.zip`);
        console.log(content);
        const link = document.createElement('a');
        link.setAttribute('href', 'data:application/zip;base64,' + content);
        link.setAttribute('id', 'csvDownloadLink');
        link.setAttribute('download', `${sAccount}-Landscape.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });

    } else window.alert('Please wait for the data to finish accumulating.');
  };

  return (
    <div className="LandscapeInfoPage">
      <div className="LandscapeInfoControlPanel">
        <select onChange={e => uAccount(e.target.value)} value={sAccount}>
          {sAccounts.map(account => {
            return <option value={account.Id} key={account.Id}>{account.Name}</option>;
          })}
        </select>
        {sAccount === '597539275125' && <input onChange={e => uClient(e.target.value)} value={sClient} placeholder="Client Tag"></input>}
        <button onClick={handleGetLandscape}>Get Landscape</button>
        <button onClick={handleDownloadCsv}>Download CSV</button>
        <p>{sStatus}</p>
      </div>
      <div className="LandscapeInfoDisplay">
        <h1>Network Interfaces</h1>
        <table>
          <tbody>
            <tr>
              {tabInfo[3].headers.map(header => {
                return <th key={header}>{header}</th>;
              })}
            </tr>
            {tab4.map(nInterface => {
              return (
                <tr key={nInterface[1]}>
                  {nInterface.map((cell, cellIndex) => {
                    return <td key={cellIndex}>{cell}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <h1>Volumes</h1>
        <table>
          <tbody>
            <tr>
              {tabInfo[2].headers.map(header => {
                return <th key={header}>{header}</th>;
              })}
            </tr>
            {tab3.map(volume => {
              return (
                <tr key={volume[1]}>
                  {volume.map((cell, cellIndex) => {
                    return <td key={cellIndex}>{cell}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <h1>Security Groups</h1>
        <table>
          <tbody>
            <tr>
              {tabInfo[1].headers.slice(1).map(header => {
                return <th key={header}>{header}</th>;
              })}
            </tr>
            {tab2.map(group => {
              return (
                <tr key={`${group[0]}`}>
                  {group.slice(1).map((cell, cellIndex) => {
                    return <td key={cellIndex}>{cell}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <h1>Instances</h1>
        <table>
          <tbody>
            <tr>
              {tabInfo[0].headers.map(header => {
                return <th key={header}>{header}</th>;
              })}
            </tr>
            {tab1.map(instance => {
              return (
                <tr key={instance[1]}>
                  {instance.map((cell, cellIndex) => {
                    return <td key={cellIndex}>{cell}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

};

LandscapeInfo.propTypes = {

};

export default LandscapeInfo;


// WEBPACK FOOTER //
// ./src/components/content/landscapeInfo/landscapeInfo.js